<template>
  <div
    class="three-scene"
    ref="three-scene"
    @selectstart="
      () => {
        return false;
      }
    "
  >
    <div
      @pointerdown="
        (e) => {
          // e.preventDefault();
          e.stopPropagation();
        }
      "
      class="btn"
      v-if="true"
    >
      <!-- <button @click="testPoint('B1B2','F2','03-A02-014-WM-26-030202')">测试1</button> -->
      <div class="backA" ref="backA" @click="backA"></div>
      <div class="backA" ref="backD" @click="backD"></div>
      <!-- <button @click="testPaking(true)">进入停车场</button>
    <button @click="testPaking(false)">离开停车场</button> -->
      <!-- <button @click="testLift(true)">显示电梯</button>
    <button @click="testLift(false)">关闭电梯</button> -->
      <!-- <button @click='testGG("SBF")'>SBF</button>
      <button @click="testGG('PDJ_A')">PDJ_A</button>
      <button @click="testGG('PDJ_D')">PDJ_D</button>
      <button @click="testGG('XFBF')">XFBF</button>
      <button @click="testGG('up')">up</button>
      <button @click="testMr">回到初始</button>
      <button @click="testfloor('B1B2','F1')">楼层测试1F</button>
      <button @click="testfloor('B1B2','F2')">楼层测试2F</button>
      <button @click="testfloor('B1B2','F3')">楼层测试3F</button>
      <button @click="testfloor('B1B2','F4')">楼层测试4F</button>
      <button @click="testfloor('B1B2','F5')">楼层测试5F</button>
      <button @click="testFloorMerge('B1B2')">楼层测试恢复</button> -->
      <!-- <button @click="switchSceneClick">场景是否可以dianjiapi</button> -->
      <!-- 
      <button @click="recovery3Building">恢复B3栋楼</button>

      <button @click="underGround">切换到地下</button>
      <button @click="onGround">切换到地上</button> -->
      <!-- <button class="ceShi" @click="search">测试</button>
      <button class="ceShi" @click="search1">测试1</button> -->
    </div>
    <!-- <div
      class="B3"
      :class="chosenB3 ? ['chosenB3'] : ''"
      @pointerdown="b3Click"
    ></div> -->
    <div
      ref="buildding"
      class="builddingBorder"
      v-for="(item, index) in builddingList"
      :key="index"
      :class="[item, chosenBuildding == item ? `${item}Chosen` : '']"
      @pointerdown="chosen(item)"
    ></div>
    <!-- <div class="smokeWarnimg">
      <div class="close" @pointerdown="closeDialog"></div>
    </div>
    <div class="beng">
      <div class="bengClose" @pointerdown="closeBeng"></div>
    </div> -->
    <!-- <div class="PDJInfo"></div> -->
    <!-- <water-info
      :waterData="waterData"
      @closePannel="closePannel"
      v-if="waterPannel1"
    ></water-info> -->
    <!-- <water-info :waterData="waterData2"></water-info> -->
    <!-- 环境监测点位icon -->
    <!-- <div
      class="hjjc"
      v-for="(item, index) in evPointsList"
      :class="`hjjc${index + 1}`"
      @pointerdown="evDetail(item)"
    ></div> -->
    <!--环境监测信息看板 -->
    <!-- <div class="evInfo"></div> -->

    <div class="flow"></div>

    <!-- <div
      class="test"
      style="width:100px; height:100px;background-color:red;position:absolute"
    ></div> -->
    <div class="switchover" v-show="isSwitchover"></div>
    <!-- <div class="tieTu"></div> -->
    <!-- <div class="psDom"></div> -->
  </div>
</template>
<script>
import Change from "./Change-1";
import E from "run-scene-v2";
const { RunScene, Utils } = E;
import bus from "./Bus";
const sceneKey = "202208151726425230081001202243";
let runScene = null;
let change = null;
export default {
  name: "three-scene",
  props: {
    showMenu: Boolean,
  },
  data() {
    return {
      // change: null,
      // runScene: null,
      propPath: "",
      propPathFrom: "",
      isShuiLunji: false,
      isOpen: true,
      isSwitchover: false,
      test: 0,
      isClick: true,
      chosenBuildding: "",
      builddingList: ["B3", "A1", "A2", "B1B2"],
      evPointsList: [
        "07-A01-027-HJ-38-000001",
        "07-A01-027-HJ-37-000001",
        "07-A01-027-HJ-37-000002",
      ],
      buildToNo: {
        "01": "A1",
        "02": "A2",
        "03": "B1B2",
        "04": "B3",
      },
      buildState: {
        B3: true,
        A1: true,
        A2: true,
        B1B2: true,
      },
      isMyShow: true,
    };
  },
  watch: {
    $route: "getPath",
  },
  mounted() {
    // 加载场景
    this.loadScene();
    // 打印点击的模型接口
    // bus.on("logClickModel", this.logClickModel);
    // bus.on("logClickModel", (m) => {
    //   this.logClickModel(m);
    // });
    bus.on("logClickModel", this.logClickModel);
    bus.on("switchover", this.showSwitchover);
    bus.on("unChosenB3", () => {
      // this.chosenB3 = false;
    });
    bus.on("backToMr", () => {
      this.chosenBuildding = "";
    });
    bus.on("getRouter", (isTo = false) => {
      if (!isTo) return this.$route.path;
      return this.propPathTo;
    });
    bus.on("nowPath", (res) => {
      this.$refs.buildding.map((i, index) => {
        let name = i.classList[1];
        i.className = ["builddingBorder", name].join(" ");
        Object.keys(this.buildState).map((key) => {
          this.buildState[key] = true;
        });
      });
      if (res.length !== 0) {
        res.map((i) => {
          if (i === "05" || i === "06" || i === "07") return false;
          let dom = document.querySelector(`.${this.buildToNo[i]}`);
          dom.classList.add(`${this.buildToNo[i]}Issue`);
          this.buildState[this.buildToNo[i]] = false;
        });
      }
    });
    bus.on("initDom", () => {
      this.initDom();
    });
  },
  methods: {
    initDom() {
      this.$refs.buildding.map((i, index) => {
        let name = i.classList[1];
        i.className = ["builddingBorder", name].join(" ");
        Object.keys(this.buildState).map((key) => {
          this.buildState[key] = true;
        });
      });
    },
    getPath(to, from) {
      this.propPathTo = to.path;
      this.propPathFrom = from.path;
      if (this.$route.path !== "/eletransfrom") {
        this.$refs.backA.style.display = "none";
        this.$refs.backD.style.display = "none";
      }
      if (change.parking) {
        change.parking.showParkingFlag(to.path);
      }
      if (to.path === "/environment") {
        if (change.parking) {
          change.parking.pipeline.visible = true;
        }
      } else {
        if (change.parking) {
          change.parking.pipeline.visible = false;
        }
      }
      if (
        to.path === "/environment" ||
        to.path === "/waterCons" ||
        to.path === "/eleCons" ||
        to.path === "/firecontrol/0" ||
        to.path === "/aircondition" ||
        to.path === "/gateway" ||
        to.path === "/monitoring"
      ) {
        if (change.border) {
          change.border.spriteMyVisible(false);
        }
        this.isMyShow = true;
      } else {
        if (change.border) {
          change.border.spriteMyVisible(false);
        }
        this.isMyShow = false;
      }
      if (to.path === "/warin") {
        if (change.border) {
          change.border.isShowBuilddingSprite = false;
          change.border.builddingSpriteVisible("all", false);
        }
      } else {
        if (change.border) change.border.isShowBuilddingSprite = true;
      }
      bus.emit("clearTiemr");
    },
    search() {
      change.pdjevent.searchView("05-B01-025-GD-03-000013");
    },
    search1() {
      change.ponintstate.searchCarView("Car05-B01-025-CG-12-003059");
    },
    backA() {
      bus.emit("closBack", false);
      change.pdjevent.backPdj("pdjA", true);
    },
    backD() {
      bus.emit("closBack", false);
      change.pdjevent.backPdj("pdjD", true);
    },
    testPoint(buildding, floor, pointNum) {
      change.floor.focusFloorPoint(buildding, floor, pointNum);
    },
    testLift(isShow) {
      // change.floor.showLift(isShow);
      bus.emit("lift", isShow);
    },
    testPaking(go) {
      // change.parking.goToParking(go);
      bus.emit("parking", go);
      // bus.emit('back')
    },
    testfloor(buildding, floor) {
      change.floor.floorDispose(buildding, floor);
    },
    testFloorMerge(buildding) {
      change.floor.floorMerge(buildding);
    },
    testGG(which) {
      // change.floorExplosion.returnBuilding(isShow);
      change.switchover.changeScene(which);
    },
    // console.log(change,"change");
    testMr() {
      change.floor.backToMr();
    },
    b3Click() {
      change.floorExplosion.floorBQVisible(true);
      this.chosenB3 = true;
    },
    chosen(floor) {
      change.floor.focusBuilding(floor, this.isMyShow);
      bus.emit("getClickBuild", floor);
      if (!this.buildState[floor]) return;
      this.chosenBuildding = floor;
    },
    switchSceneClick() {
      change.events.changeClickState(this.isClick);
      this.isClick = !this.isClick;
    },

    recovery3Building() {
      change.floorExplosion.isShowBuilding("B3", true);
    },
    // testLight() {
    //   change.switchover.cellIsShow(this.test);
    // },
    showSwitchover(isShow) {
      this.isSwitchover = isShow;
    },
    underGround() {
      change.switchover.under("SBF");
    },
    onGround() {
      change.switchover.quitConceal();
    },
    closeDialog() {
      change.border.smokeSpriteVisable(false);
    },
    closeBeng() {
      change.border.bengSpriteVisable(false);
    },
    evDetail(num) {
      change.border.setEvInfoSpritePosition(num);
      bus.emit("getNum", num);
    },
    // 加载场景
    loadScene() {
      runScene = new RunScene({
        instanceClone: false,
        render2: true,
        render3: true,
        texture: {
          // load: false,
          // lazyload: {
          //   open: true,
          //   IntervalTime: 16.6,
          // },
        },
        msg: {
          show: true,
        },
        renderConfig: {
          // 是否允许设置模型位置后自动渲染最新效果
          matrixAutoUpdate: true,
        },
        //配置该选项为true 则可强制重置id
        coverSameId: true,
        /**
            msg?: {
            是否显示打印，默认显示
              show: boolean = true
             显示打印的等级 默认显示基础打印
              level: "base" | 'detail' =  base
              }
             是否渲染
              run?: boolean = true
             decode 的路径
              decodePath?: string = ./draco/
             是否显示fps 默认关
              showFps?: boolean = false
             是否延迟加载 默认不延迟
              loadInterval?: number = 0
             模式 默认运行模式
              mode?: 'editor' | 'debug' | 'running' = 'running
             texture?:{
             是否加载贴图
               load?:boolean = true
               lazyload?:{
             是否懒加载贴图 默认是
                 open?:boolean = false,
             懒加载的时间区间 默认为16.0ms
                 IntervalTime?:number = 16.6
              },
             贴图质量 可大幅度降低显存占用 0-1 之间
              quality?:number = 1
             }
             是否加载实例后的模型 节省性能 默认关闭
              instanceClone?: boolean =false
             2drenderer
              render2?: boolean = false
             3drenderer
              render3?: boolean, = false
               */
      })
        .load({
          // path: "./assets/scene.glb",
          path:
            "https://test2-1303915342.cos.ap-shanghai.myqcloud.com/slzx/scene.glb",
          // path:"http://192.168.3.8:8080/file?path=project/linkpoint/&key=202208151726425230081001202243",
          dom: this.$refs["three-scene"],
        })
        .on("complete", () => {
          this.onDone();
        });

      change = new Change(runScene);
      runScene.cb.load.progress.add("progress", (s) => {
        this.$emit("loadProgress", s);
        // console.log(`进度:${s}`);
      });
      // this.$store.state.changeEvent = this.change;
    },

    onDone() {
      this.$emit("onDone");
      console.log("场景加载完毕~");
    },

    logClickModel(model) {
      console.log(`点击的模型:${model}`);
    },
  },
  // 场景自带销毁
  destroyed() {
    runScene && runScene.dispose();
  },
};
</script>
<style lang="scss">
.hjjc {
  z-index: 2;
  position: absolute;
  width: 46px;
  height: 64.03px;
  opacity: 1;
  background-image: url("../../../public/assets/shuihuanjing-zhengchang.png");
  background-size: 100%;
  background-repeat: no-repeat;
}
</style>
<style lang="scss" scoped>
// 场景
.three-scene {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 0;
  .PDJInfo {
    width: 100px;
    height: 100px;
    background-color: red;
    position: absolute;
    z-index: 2;
    opacity: 0;
  }
  .smokeWarnimg {
    width: 240px;
    height: 245px;
    background-image: url("../../assets/pagesImg/dialog-img-normal.png");
    background-size: cover;
    position: absolute;
    backdrop-filter: blur(5px);
    z-index: 2;
    opacity: 0;
    .close {
      width: 24px;
      height: 24px;
      background-color: transparent;
      cursor: pointer;
      left: 209px;
      top: 7px;
      position: absolute;
    }
  }
  .btn {
    position: absolute;
    z-index: 10;
    display: flex;
    top: 193px;
    left: 541px;
    button {
      width: 100px;
      height: 60px;
      cursor: pointer;
      pointer-events: all;
      font-size: 25px;
      background: rgba(17, 93, 156, 0.7);
      color: white;
      border: none;
      outline: none;
      margin-right: 20px;
      border-radius: 10px;
      &:hover {
        background: rgba(0, 153, 255, 0.7);
      }
    }
  }
  .hjjc1 {
    display: none !important;
  }
  .evInfo {
    z-index: 2;
    position: absolute;
    width: 100px;
    height: 200px;
    opacity: 0;
  }
  .switchover {
    width: 100%;
    height: 100%;
    background-color: black;
    z-index: 100000;
    position: absolute;
  }
  .builddingBorder {
    width: 70px;
    height: 70px;
    // background-color: rgba(0, 0, 0, 0);
    // background-image: url("../../../public/assets/b3.png");
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;
    z-index: 2;
    font-size: 40px;
    text-align: center;
    line-height: 100px;
    // background-color: red;
    opacity: 0;
  }
  .B3 {
    background-image: url("../../../public/assets/b3.png");
  }
  // "A1", "A2", "B1B2"
  .A1 {
    background-image: url("../../../public/assets/louyubaiopai_A1moren.png");
    background-size: 100%;
    background-repeat: no-repeat;
  }
  .A2 {
    background-image: url("../../../public/assets/louyubiaopai_A2moren.png");
  }
  .B1B2 {
    width: 100px;
    height: 100px;
    background-image: url("../../../public/assets/louyubiaopai_B1_B2moren.png");
  }
  .B3Chosen {
    background-image: url("../../../public/assets/louyubiaopai_B3dianji.png") !important;
    opacity: 1 !important;
  }
  .A1Chosen {
    background-image: url("../../../public/assets/louyubaiopai_A1dianji.png") !important;
    opacity: 1 !important;
  }
  .A2Chosen {
    background-image: url("../../../public/assets/louyubiaopai_A2dainji.png") !important;
    opacity: 1 !important;
  }
  .B1B2Chosen {
    background-image: url("../../../public/assets/louyubiaopai_B1_B2dianji.png") !important;
    opacity: 1 !important;
  }
  .chosen {
    background-image: url("../../../public/assets/louyubiaopai_B3dianji.png") !important;
  }
  .A1Issue {
    background-image: url("../../../public/assets/A1_moren.png") !important;
  }
  .A2Issue {
    background-image: url("../../../public/assets/louyubaiopai_A2chupeng.png") !important;
  }
  .B1B2Issue {
    width: 100px;
    height: 100px;
    background-image: url("../../../public/assets/louyubiaopai_B1_B2chupeng.png") !important;
  }
  .B3Issue {
    background-image: url("../../../public/assets/louyubiaopai_B3chupeng.png") !important;
  }
  .B2Issue {
    background-image: url("../../../public/assets/louyubiaopai_B2chupeng.png") !important;
  }
  .B1Issue {
    background-image: url("../../../public/assets/louyubiaopai_B1chupeng.png") !important;
  }
  .beng {
    width: 240px;
    height: 245px;
    background-image: url("../../assets/pagesImg/dialog-img-normal.png");
    position: absolute;
    z-index: 2;
    opacity: 0;
    backdrop-filter: blur(5px);
    .bengClose {
      width: 24px;
      height: 24px;
      background-color: transparent;
      cursor: pointer;
      left: 209px;
      top: 7px;
      position: absolute;
    }
  }
  .flow {
    width: 80 * 2px;
    height: 26 * 2px;
    z-index: 2;
    position: absolute;
    text-align: center;
    opacity: 0;
    color: white;
    font-size: 12 * 1.4px;
    background-image: url("../../../public/assets/yeweibeijingtu.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  // .psDom {
  //   width: 130px;
  //   height: 64px;
  //   font-size: 10px;
  //   z-index: 2;
  //   position: absolute;
  //   // text-align: center;
  //   line-height: 24px;
  //   opacity: 0;
  //   color: white;
  //   background-image: url("../../../public/assets/给排水状态背景.png");
  //   background-size: 100%;
  //   background-repeat: no-repeat;
  // }
  .block {
    display: block !important;
  }
  .none {
    display: none !important;
  }
  .backA {
    width: 112px;
    height: 44px;
    display: none;
    background-image: url("../../../public/assets/chushishijiao_moren.png");
    background-size: 100%;
    background-repeat: no-repeat;
    cursor: pointer;
    &:hover {
      background-image: url("../../../public/assets/chushishijiao_dainji.png");
    }
  }
  .show {
    opacity: 1 !important;
  }
  .ceShi {
    position: absolute;
    top: 106px;
    left: 3px;
  }
  .tieTu {
    position: absolute;
    z-index: 30;
    width: 100px;
    height: 100px;
    opacity: 0;
    background-color: red;
  }
}
</style>
